<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>Candidate</th>
        <th>Title</th>
        <th></th>
        <th>Date</th>
        <th class="u-hide-mobile">Supervisor</th>
        <th class="u-text-left">Topics</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="examList.length == 0">
        <td colspan="7">
          <no-results-found
            title="No Results Found"
            message="Maybe change the search and filters and try again?"
          ></no-results-found>
        </td>
      </tr>
      <tr v-else v-for="exam in examList" :key="exam.id">
        <td>
          <exam-action-button v-bind:exam="exam"></exam-action-button>
        </td>
        <td>{{ exam.candidate.full_name }}</td>
        <td class="u-text-left">
          {{ exam.title }}
        </td>
        <td>
          <status-tag
            v-bind:status="exam.result.status"
            v-bind:label="exam.result.name"
          ></status-tag>
          <div v-if="exam.is_closed">
            {{ getPercentageMark(exam) }}
          </div>
        </td>
        <td>{{ formatDate(exam.date) }}</td>
        <td>{{ exam.supervisor.full_name }}</td>
        <td class="u-hide-mobile">
          {{ exam.display_topics }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import { DateFormatter } from "@/functions/dateFormat.function";
import StatusTag from "@/components/StatusTag";
import ExamActionButton from "@/components/exams/ExamActionButton";
import NoResultsFound from "@/components/PlaceholderNoResults";

export default {
  name: "exam-table",
  components: {
    StatusTag,
    ExamActionButton,
    NoResultsFound
  },
  props: {
    error: {},
    examList: Array
  },
  computed: {
    ...mapGetters("core", ["userProfile"])
  },
  methods: {
    formatDate: function(dateString) {
      return DateFormatter(dateString);
    },
    getPercentageMark(exam) {
      var result = (exam.marks_awarded / exam.marks_available) * 100;
      if (Number.parseInt(result) != result) {
        result = Number.parseFloat(result).toFixed(1);
      }
      if (result > 1000) {
        return "0 %";
      } else {
        return result + " %";
      }
    }
  }
};
</script>
